import React from 'react';

const totalQueries = 12;
const lastQuerySubmittedDate = '18 July 2026, 12:09';

export default function QueryDetails({ totalCount = 88 }) {
  return (
    <section className="ca-query-details" aria-labelledby="query-management-title">
      <div className="ca-query-details__heading">
        <h1 id="query-management-title" className="ca-query-details__title">
          Query Management
        </h1>
        <span className="ca-query-details__count">Total Count: {totalCount}</span>
      </div>

      <div className="ca-query-details__summary">
        <div className="ca-query-details__card">
          <span className="ca-query-details__label">Total Queries</span>
          <strong className="ca-query-details__value">{totalQueries}</strong>
        </div>
        <div className="ca-query-details__card">
          <span className="ca-query-details__label">Last Query Submitted Date</span>
          <strong className="ca-query-details__value">{lastQuerySubmittedDate}</strong>
        </div>
      </div>
    </section>
  );
}